module.exports = __webpack_public_path__ + "img/deliver-img-1-2.5cb8a725.png";